// src/components/TopbarNav.jsx

import React, { useState, useEffect, useRef } from "react";
import { FaSearch, FaRegCommentDots, FaRegBell, FaUserCircle, FaBars } from "react-icons/fa";
import ViewStaffModal from "./ViewStaffModal";

// ✅ Add onSearchChange to the props
const Topbar = ({ onSidebarToggle, onSearchChange }) => {
    const [showMsgPopup, setShowMsgPopup] = useState(false);
    const [showNotifPopup, setShowNotifPopup] = useState(false);
    const [showProfileModal, setShowProfileModal] = useState(false);
    const wrapperRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowMsgPopup(false);
                setShowNotifPopup(false);
                setShowProfileModal(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const togglePopup = (type) => {
        setShowMsgPopup(type === "msg" ? !showMsgPopup : false);
        setShowNotifPopup(type === "notif" ? !showNotifPopup : false);
        if (type === "profile") {
            setShowProfileModal(prev => !prev);
        } else {
            setShowProfileModal(false);
        }
    };

    const [userId, setUserId] = useState(null);
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"));
        if (user && user.id) {
            setUserId(user.id);
        }
    }, []);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        // ✅ Call the prop function to pass the search query to the parent
        if (onSearchChange) {
            onSearchChange(value);
        }
    };

    return (
        <>
            {/* Topbar container */}
            <div
                ref={wrapperRef}
                className="fixed top-0 left-0 w-full md:left-64 md:w-[calc(100%-16rem)] h-16 bg-white flex items-center justify-between px-4 md:px-6 shadow-sm z-40"
            >
                {/* Mobile sidebar toggle button */}
                <button 
                  onClick={onSidebarToggle} 
                  className="md:hidden text-gray-700 hover:text-orange-500 p-2 rounded"
                >
                    <FaBars size={20} />
                </button>

                {/* Search input */}
                <div className="flex items-center bg-gray-100 rounded-full px-4 py-2 flex-1 md:w-64 max-w-xs md:max-w-none mr-2 hidden sm:flex">
                    <FaSearch className="text-gray-500 mr-2" />
                    <input
                        type="text"
                        placeholder="Search"
                        className="bg-transparent outline-none text-sm w-full text-gray-600"
                        // ✅ Set value and onChange to control the input
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                </div>

                {/* Icons section */}
                <div className="flex items-center space-x-4 md:space-x-6 relative">
                    {/* ... (Your icons and popups remain the same) ... */}
                </div>
            </div>

            {/* Profile modal */}
            {showProfileModal && userId && (
                <ViewStaffModal
                    staffId={userId}
                    closeModal={() => setShowProfileModal(false)}
                />
            )}
        </>
    );
};

export default Topbar;